import PropTypes from 'prop-types';

// eslint-disable-next-line
export const annotationsType = PropTypes.shape({
  type: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
  properties: PropTypes.object,
});
